<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="EditJobLevel" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="名称" prop="PaJobLevel.name">
            <el-input class="input-item" v-model="formData.PaJobLevel.name"
              :clearable="true" placeholder="名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formData.PaJobLevel.type!=='group'">
          <el-form-item label="所属序列" prop="PaJobLevel.gcode">
            <el-select class="input-item" v-model="formData.PaJobLevel.gcode" :clearable="true" filterable
              placeholder="所属序列" :loading="EditJobLevel.gcode.impl.loading"
              @visible-change="EditJobLevel.gcode.impl.onVisibleChange"
              @change="onGcodeValueChange">
              <el-option v-for="item in EditJobLevel.gcode.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formData.PaJobLevel.type!=='group'">
          <el-form-item label="薪级编码" prop="PaJobLevel.code">
            <el-input class="input-item" v-model="formData.PaJobLevel.code"
              :clearable="true" placeholder="薪级编码"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formData.PaJobLevel.type!=='group'">
          <el-form-item label="所属部门" prop="PaJobLevel.deptId">
            <el-cascader class="input-item" v-model="formData.PaJobLevel.deptId" :clearable="true" filterable
              placeholder="所属部门" :loading="EditJobLevel.deptId.impl.loading" :props="{value: 'deptId', label: 'deptName', checkStrictly: true}"
              @visible-change="EditJobLevel.deptId.impl.onVisibleChange" :options="EditJobLevel.deptId.impl.dropdownList"
              @change="onDeptIdValueChange">
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formData.PaJobLevel.type!=='group'">
          <el-form-item label="岗位工资" prop="PaJobLevel.jobSalary">
            <el-input-number class="input-item" v-model="formData.PaJobLevel.jobSalary"
              :clearable="true"
              placeholder="岗位工资"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="描述" prop="PaJobLevel.detail">
            <el-input class="input-item" v-model="formData.PaJobLevel.detail"
              :clearable="true" placeholder="描述"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="PaJobLevel.remark">
            <el-input class="input-item" v-model="formData.PaJobLevel.remark"
              :clearable="true" placeholder="备注"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="排序" prop="PaJobLevel.sort">
            <el-input-number class="input-item" v-model="formData.PaJobLevel.sort"
              :clearable="true"
              placeholder="排序"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              取消
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('EditJobLevel:EditJobLevel:update')"
              @click="onUpdateClick()">
              保存
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaJobLevelController, DictionaryController, SysDeptController} from '@/api';

export default {
  name: 'EditJobLevel',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    },
    id: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      formData: {
        PaJobLevel: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          deptId: undefined,
          deptTid: undefined,
          detail: undefined,
          jobSalary: undefined,
          remark: undefined,
          sort: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          sysUser: {
          },
          isDatasourceInit: false
        }
      },
      rules: {
        'PaJobLevel.name': [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ],
        'PaJobLevel.deptId': [
          {required: true, message: '请输入所属部门', trigger: 'blur'}
        ],
        'PaJobLevel.gcode': [
          {required: true, message: '请输入所属序列', trigger: 'blur'}
        ],
        'PaJobLevel.code': [
          {required: true, message: '请输入薪级编码', trigger: 'blur'}
        ]
      },
      EditJobLevel: {
        formFilter: {
        },
        formFilterCopy: {
        },
        gcode: {
          impl: new DropdownWidget(this.loadGcodeDropdownList)
        },
        deptId: {
          impl: new DropdownWidget(this.loadDeptIdDropdownList, true, 'deptId')
        },
        BtnDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    /**
     * 所属序列下拉数据获取函数
     */
    loadGcodeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_job_level_group'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 所属序列选中值改变
     */
    onGcodeValueChange (value) {
    },
    /**
     * 所属部门下拉数据获取函数
     */
    loadDeptIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        SysDeptController.list(this, params).then(res => {
          resolve(res.data.dataList);
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 所属部门选中值改变
     */
    onDeptIdValueChange (value) {
    },
    /**
     * 更新编辑薪级
     */
    refreshEditJobLevel (reloadData = false) {
      this.loadPaJobLevelData().then(res => {
        if (!this.EditJobLevel.isInit) {
          // 初始化下拉数据
          this.EditJobLevel.deptId.impl.onVisibleChange(true).then(res => {
            this.formData.PaJobLevel.deptId = findTreeNodePath(this.EditJobLevel.deptId.impl.dropdownList, this.formData.PaJobLevel.deptId, 'deptId');
          });
        }
        this.EditJobLevel.isInit = true;
      }).catch(e => {});
    },
    /**
     * 保存
     */
    onUpdateClick () {
      this.$refs.EditJobLevel.validate((valid) => {
        if (!valid) return;
        // 如果是级联表格的添加或者编辑弹窗
        if (this.supportCascadeAdd === '1') {
          let formData = {
            gcodeDictMap: findItemFromList(this.EditJobLevel.gcode.impl.dropdownList, this.formData.PaJobLevel.gcode, 'id'),
            deptIdDictMap: findItemFromList(this.EditJobLevel.deptId.impl.dropdownList, this.formData.PaJobLevel.deptId, 'id'),
            ...this.formData.PaJobLevel
          };
          this.onCancel(true, formData);
          return;
        }
        let deptTid = this.formData.PaJobLevel.deptId;
        let deptId = Array.isArray(deptTid) ? deptTid[deptTid.length - 1] : undefined;
        let params = {
          paJobLevelDto: {
            id: this.id,
            pid: this.formData.PaJobLevel.pid,
            type: this.formData.PaJobLevel.type,
            code: this.formData.PaJobLevel.code,
            gcode: this.formData.PaJobLevel.gcode,
            name: this.formData.PaJobLevel.name,
            deptId: deptId,
            deptTid: deptTid,
            detail: this.formData.PaJobLevel.detail,
            jobSalary: this.formData.PaJobLevel.jobSalary,
            remark: this.formData.PaJobLevel.remark,
            sort: this.formData.PaJobLevel.sort
          }
        };

        PaJobLevelController.update(this, params).then(res => {
          this.$message.success('保存成功');
          this.onCancel(true);
        }).catch(e => {});
      });
    },
    /**
     * 获取绩效薪级详细信息
     */
    loadPaJobLevelData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.PaJobLevel.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          PaJobLevelController.view(this, params).then(res => {
            this.formData.PaJobLevel = {...res.data, isDatasourceInit: true};
            if (this.formData.PaJobLevel.gcodeDictMap && this.EditJobLevel.gcode.impl.dirty) {
              this.EditJobLevel.gcode.impl.dropdownList = [this.formData.PaJobLevel.gcodeDictMap];
            }
            if (this.formData.PaJobLevel.deptIdDictMap && this.EditJobLevel.deptId.impl.dirty) {
              this.EditJobLevel.deptId.impl.dropdownList = [this.formData.PaJobLevel.deptIdDictMap];
            }
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.CourseSection.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaJobLevel: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          deptId: undefined,
          deptTid: undefined,
          detail: undefined,
          jobSalary: undefined,
          remark: undefined,
          sort: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          sysUser: {
          },
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshEditJobLevel();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.PaJobLevel = {
        ...this.rowData
      }
    }
  },
  watch: {
  }
}
</script>
